module.exports = __webpack_public_path__ + "static/media/bannerFlashSale.f6ae10aa.jpg";